import { __assign } from '../../../_virtual/_tslib.js';
import React, { useState } from 'react';
import PopoverBase from '@mui/material/Popover';
import { classNames } from '../../../utils/common/styling.js';
import Drawer from '@mui/material/Drawer';
import { useIsDesktop } from '../../../utils/common/screen.js';
import { styles } from './Popover.styles.js';

var Popover = function (_a) {
    var PopoverComponent = _a.PopoverComponent, AnchorComponent = _a.AnchorComponent, wrapperClassName = _a.wrapperClassName, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, usePopoverInMobile = _a.usePopoverInMobile, popoverProps = _a.popoverProps;
    var isDesktop = useIsDesktop();
    var _c = useState(null), anchor = _c[0], setAnchor = _c[1];
    var isOpen = Boolean(anchor);
    var openPopover = function (event) {
        setAnchor(event.currentTarget);
    };
    var closePopover = function (e) {
        setAnchor(null);
        onClose(e);
    };
    var commonProps = { open: isOpen, onClose: closePopover };
    var isPopoverComponent = isDesktop || usePopoverInMobile;
    var _PopoverComponent = React.createElement(PopoverComponent, { closePopover: closePopover });
    var PopoverWrapperComponent = isPopoverComponent ? (React.createElement(PopoverBase, __assign({ classes: { paper: styles.popoverPaper }, anchorEl: anchor, anchorOrigin: { vertical: "bottom", horizontal: "center" }, transformOrigin: { vertical: "top", horizontal: "center" } }, commonProps, popoverProps), _PopoverComponent)) : (React.createElement(Drawer, __assign({ classes: { paper: styles.drawerPaper }, anchor: "bottom" }, commonProps), _PopoverComponent));
    return (React.createElement("div", { className: classNames(styles.wrapper, wrapperClassName) },
        React.createElement(AnchorComponent, { openPopover: openPopover }),
        PopoverWrapperComponent));
};

export { Popover as default };
//# sourceMappingURL=Popover.js.map
